/**
 * Selection and deselection should respond only to the primary (left) mouse button.
 * Middle (1) and right (2) are ignored when the native button is present.
 * Missing button (some touch/synthetic paths) is treated as allowed.
 *
 * @param {MouseEvent | PointerEvent | undefined | null} evt
 * @returns {boolean}
 */
export function isPrimaryMouseButton(evt) {
  if (evt == null) return true;
  if (typeof evt.button !== "number") return true;
  return evt.button === 0;
}
